import React from 'react'

const ChatHeader = () => {
  return (
    <>
      <header>
      <h1 className="text-center my-4" style={{ color: "#ffff" }}>
        
      </h1>
      </header>
    </>
  )
}

export default ChatHeader